import { API_URL } from '../../config';

const normalizeTurn = (data = {}) => ({
  handled: data.handled === true,
  mode: data.mode || 'answer',
  conversationId: data.conversationId || null,
  message: data.message || '',
  semanticDecision: data.semanticDecision || null,
  conversationContextPatch: data.conversationContextPatch || null,
  freeTrial: data.freeTrial || null,
  sourceStatus: data.sourceStatus || null,
  source: data.source || 'mi_conversation'
});

export const sendMiConversationTurn = async ({
  conversationId,
  text,
  conversationContext = {},
  host = {},
  language = 'pt-BR',
  fetchImpl = globalThis.fetch,
  apiBaseUrl = API_URL
} = {}) => {
  if (!conversationId || !text || typeof fetchImpl !== 'function') {
    return { ok: false, reason: 'missing_conversation_or_text' };
  }

  try {
    const token = await host.user?.getIdToken?.();
    if (!token) return { ok: false, reason: 'auth_token_unavailable' };

    const response = await fetchImpl(`${apiBaseUrl}/mi/conversations/${encodeURIComponent(conversationId)}/turn`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({
        text,
        language,
        conversationContext,
        currentGame: host.canonicalGame || host.profile?.mainGame || null,
        currentScreen: 'mi',
        pendingSkill: conversationContext?.pendingSkill || null
      })
    });

    if (!response.ok) {
      return { ok: false, reason: `http_${response.status}` };
    }

    const data = await response.json().catch(() => null);
    return { ok: true, turn: normalizeTurn(data || {}) };
  } catch (error) {
    return { ok: false, reason: 'request_failed', error };
  }
};

export default sendMiConversationTurn;
